import React from 'react';
import PropTypes from 'prop-types';
import ImportantToggle from 'components/consumer/ImportantToggle';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import { customItem, readyToShipItem, decideLaterItem } from './itemContent';
const getValidTabItems = conditions => {
  let finalItems = [customItem];
  const {
    showReadyToShip,
    isEFGInternal,
    showDecideLater
  } = conditions;
  if (!isEFGInternal) {
    if (showReadyToShip) {
      finalItems.push(readyToShipItem);
    }
    if (showDecideLater) {
      finalItems.push(decideLaterItem);
    }
  } else if (showReadyToShip && isEFGInternal) {
    finalItems = [readyToShipItem];
  }
  return finalItems;
};
const PDPShopTabsBarUI = ({
  hideShopsTabBar = false,
  isEFGInternal = false,
  loading = false,
  price,
  showDecideLater = false,
  showReadyToShip = true
}) => {
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  decideLaterItem.description = price?.max_discount_percent ? `Lock in up to ${price.max_discount_percent}% off` : price?.discount_percent ? `Lock in ${price.discount_percent}% off` : `Buy now, decide later`;
  const items = getValidTabItems({
    showReadyToShip,
    isEFGInternal,
    showDecideLater
  });
  if (hideShopsTabBar) {
    return <div className="PDPShopTabsBarUI__filler" />;
  }
  return <div className="PDPShopTabsBarUI" data-xc="PDPShopTabsBarUI">
      <ImportantToggle items={items} selected={pdpSelectedCustomizerTab} loading={loading} onClick={setPdpSelectedCustomizerTab} aria-label="Product Option Types" />
    </div>;
};
PDPShopTabsBarUI.propTypes = {
  hideShopsTabBar: PropTypes.bool,
  isEFGInternal: PropTypes.bool,
  loading: PropTypes.bool,
  price: PropTypes.shape({
    discount_percent: PropTypes.number,
    max_discount_percent: PropTypes.number
  }),
  showDecideLater: PropTypes.bool,
  showReadyToShip: PropTypes.bool
};
export default PDPShopTabsBarUI;